import React, { FunctionComponent } from "react";
import Button from "../button/Button";
import { ButtonEnum } from "designSystem/types/button-types";
import { ModalDialogProps } from "./ModalDialog";

import ModalDialog from "designSystem/components/dialog/ModalDialog";

export interface PopupDialogProps extends Omit<ModalDialogProps, "showDividers"> {

}

const PopupDialog: FunctionComponent<PopupDialogProps> = (props) => {
	const { children, showClose, ...otherProps } = props;
	const addShowClose = !children.buttons;

	children.buttons ||= (
		<Button
			design="secondary"
			onClick={props.onClose}
			res={ButtonEnum.BUTTON_CLOSE}
		/>
	);

	return (
		<ModalDialog
			showClose={showClose || addShowClose}
			showDividers
			{...otherProps}
		>
			{children}
		</ModalDialog>
	);
};

export default PopupDialog;